<template>
    <div class="flex flex-col">
        <div class="flex items-start mb-0.5">
            <div class="w-5">{{itemNumber}}.</div>
            <div class="font-bold">
                {{title}}
            </div>
        </div>
        <div class="flex">
            <div class="w-5" />
            <div class="text-xs">
                {{subtitle}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            itemNumber: {
                type: Number,
            },
            title: {
                type: String,
            },
            subtitle: {
                type: String,
                required: false,
            },
        },
    };
</script>
